"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.positioningToAlignPoints = void 0;
exports.positioningToAlignPoints = function (positioning) {
    return positioning.map(function (_a) {
        var snapPoints = _a.snapPoints, offset = _a.offset;
        return ({
            align: snapPoints.parent + " " + snapPoints.child,
            offset: offset,
        });
    });
};
//# sourceMappingURL=positioning.js.map